module.exports = __webpack_public_path__ + "img/CM-DJ-26-Nissan-Modern.b6d2bb0f.jpg";